import { useState } from 'react';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
            <a href="/" className="text-gray-900 hover:text-teal-600 transition-colors">
              METALAGRO
            </a>
          </h1>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Features
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              How It Works
            </button>
            <button onClick={() => scrollToSection('security')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Security
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-full hover:bg-teal-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-900`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left whitespace-nowrap cursor-pointer">
                Features
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left whitespace-nowrap cursor-pointer">
                How It Works
              </button>
              <button onClick={() => scrollToSection('security')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left whitespace-nowrap cursor-pointer">
                Security
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-full hover:bg-teal-700 transition-colors font-medium text-center whitespace-nowrap cursor-pointer">
                Contact Us
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
